module.exports = __webpack_public_path__ + "3354ce69be38a29ddadfcc714ed249ed.svg";